<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('sparePartReplacement.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('sparePartReplacement.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div
          class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3"
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-tooltip="$t('sparePartReplacement.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="ts-text-xs">{{
                    $t('sparePartReplacement.branchName')
                  }}</label>
                  <ts-branch-filter
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
              <div class="row ts-mt-3">
                <div class="col-md-12">
                  <label class="ts-text-xs">{{
                    $t('sparePartReplacement.location')
                  }}</label>
                  <ts-location-filter
                    :isDefaultSelect="false" 
                    :showPlaceholder="false" 
                    @filter="filterLocaton"></ts-location-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <Table
          :data="resources" 
          :columns="columns" 
          size="small"
          highlight-row
          stripe
          max-height="700"
          :loading="loading"
        >
            <template slot-scope="{ row }" slot="branchNameEn">
              {{ row.branch.branch_name_en }}
            </template>
            <template slot-scope="{ row }" slot="productNameEn">
              {{ row.product.product_name_en }}
            </template>
            <template slot-scope="{ row }" slot="LocationNameEn">
              {{ row.location.location_name_en }}
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(row)"
              >
                <a href="#" :disabled="row._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="row._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </template>
        </Table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import expandRow from './components/table-expand.vue'

export default {
  name: 'wholesaleReceipt',
  data() {
    return {
      loading: false,
      errors: new Errors(),
    }
  },
  created() {
		 this.$store.state.wholesale.replacement.dateRange = [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')]
    this.fetchData()
  },
  computed: {
    ...mapState('wholesale/replacement', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.wholesale.replacement.search
      },
      set(newValue) {
        this.$store.commit('wholesale/replacement/SET_SEARCH', newValue)
        this.$store.commit('wholesale/replacement/RESET_CURRENT_PAGE')
      },
    },
    dateRange: {
      get() {
        return this.$store.state.wholesale.replacement.dateRange
      },
      set(newValue) {
        this.$store.commit('wholesale/replacement/SET_DATE_RANGE', newValue)
      },
    },
    columns() {
      return [
        {
          type: 'expand',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            })
          },
          width: 30
        },
        { 
          title: this.$t('sparePartReplacement.branchName'),
          slot: 'branchNameEn' 
        },
        { 
          title: this.$t('sparePartReplacement.number'),
          key: 'replacement_number' 
        },
        { 
          title: this.$t('sparePartReplacement.productNameEn'),
          slot: 'productNameEn' 
        },
        { 
          title: this.$t('sparePartReplacement.serialNumber'),
          key: 'serial_no' 
        },
        { 
          title: this.$t('sparePartReplacement.location'),
          slot: 'LocationNameEn' 
        },
        { 
          title: this.$t('sparePartReplacement.date'),
          key: 'replacement_date' 
        },
        { 
          title: this.$t('sparePartReplacement.remark'),
          keyy: 'remarks' 
        },
        {
					title: this.$t('actions'),
					key: 'action',
					slot: 'action',
					fixed: 'right',
					align: 'center',
					width: 100
				}
      ]
    },
  },
  methods: {
    addNew() {location
      this.$router.push({ name: 'spare-part-replacement-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/replacement/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('wholesale/replacement/destroy', record.replacement_id)
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value) {
      this.$store.commit('wholesale/replacement/SET_BRANCH_ID', value)
      this.fetchData()
    },
    edit(record) {
      this.$store.commit('wholesale/replacement/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'spare-part-replacement-edit',
        params: { id: record.replacement_id },
      })
    },
    filterLocaton(value){
      this.$store.commit('wholesale/replacement/SET_LOCATION_ID', value)
      this.fetchData()
    }
    
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/replacement/RESET_STATE')
    next()
  },
}
</script>